
import { api } from "../api/system/apiClient";
import { SharedActions } from "../flux/actions/sharedActions";
import { StoreActionFactory } from "./storeActionFactory";
import { neverHere } from "@travellocal/utils/tsHelpers";

export default class SharedActionPromises {

  public static refreshProfile() {
    return StoreActionFactory.api(SharedActions.User.RefreshProfile, api.getProfile());
  }

  public static saveDraftMessage(enquiryId: number, messageBody: string) {
    return StoreActionFactory.action(SharedActions.Messaging.SaveDraft, messageBody, { enquiryId });
  }
  public static saveDraftSnippet(enquiryId: number, snippet: number) {
    return StoreActionFactory.action(SharedActions.Messaging.SaveSnippet, snippet, { enquiryId });
  }

  public static sendEnquiryMessage(enquiryId: number, from: IUser, messageBody: string, snippets?: number[]) {
    return StoreActionFactory.thunk<ISharedStoreState>(async (dispatch) => {
      const sendAction = () => {
        const messageInput: INewEnquiryMessageInput = { enquiryId, text: messageBody };
        if (snippets != null && snippets.length > 0) {
          messageInput.snippetIds = snippets;
        }

        switch (from.userType) {
          case UserType.Customer:
            return api.sendTextMessageToLto(messageInput);
          case UserType.LtoEmployee:
          case UserType.Administrator:
            return api.sendTextMessageToCustomer(messageInput);
          default:
            neverHere(from.userType, "Unknown usertype");
        }
      };

      await dispatch(StoreActionFactory.api(SharedActions.Messaging.Send, sendAction(), { enquiryId }));
      await dispatch(StoreActionFactory.api(SharedActions.Messaging.GetForEnquiry, api.getMessages(enquiryId), { enquiryId }));
    });
  }

  public static enquiryMessagesByEnquiryId(enquiryId: number) {
    return StoreActionFactory.api(SharedActions.Messaging.GetForEnquiry, api.getMessages(enquiryId), { enquiryId });
  }

  public static markMessagesRead(enquiryId: number) {
    // API uses the currently Authenticated user to determine who to mark as read
    return StoreActionFactory.api(SharedActions.Messaging.MarkAllRead, api.markMessagesRead(enquiryId), { enquiryId });
  }

  public static getEnquiryTerms(enquiryId: number) {
    return StoreActionFactory.api(SharedActions.Enquiries.GetEnquiryTerms, api.getEnquiryTerms(enquiryId));
  }
}
